import moment from 'moment';
import url from '../config/urlConfig';

/**
 * @returns number 0:App 1:触屏 2: 小程序
 */
export function webEntry() {
  if (
    window.CSNativeObject &&
    window.CSNativeObject.nativeSetTitle &&
    typeof window.CSNativeObject.nativeSetTitle === 'function'
  ) {
    return 0;
  } else if (
    sessionStorage.getItem('persist:emp') &&
    JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail)
      .urlQuery.type === 'B'
  ) {
    return 2;
  } else {
    return 1;
  }
}
//获取推荐码
export function getRecommendCode(type) {
  const num = type || webEntry();
  if (num === 0) {
    // app
    const cache = window.CSNativeObject.getDataLocalStorage
      ? window.CSNativeObject.getDataLocalStorage(
        JSON.stringify({ keyName: 'employeeReferral' })
      )
      : '';
    const data = cache
      ? typeof cache === 'string'
        ? JSON.parse(cache)
        : ''
      : '';
    return data
      ? moment().diff(moment(data.referralTime)) <= 3600000
        ? data.referralCode
        : ''
      : '';
  } else if (num === 1) {
    // 触屏
    return (
      window.csmbpRecommendUtil && window.csmbpRecommendUtil.getRecommendCode()
    );
  } else {
    // 小程序
    return (
      JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail)
        .urlQuery.recommendCode || ''
    );
  }
}
//更新推荐码
export function saveRecommendCode(code, type) {
  const num = type || webEntry();
  if (num === 0) {
    // app
    window.CSNativeObject.saveDataLocalStorage(
      JSON.stringify({
        employeeReferral: {
          referralCode: code,
          referralTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
      })
    );
  } else if (num === 1) {
    // 触屏
    window.csmbpRecommendUtil &&
      window.csmbpRecommendUtil.saveRecommendCode(code);
  } else {
    // 小程序
    return false;
  }
}

/**
 * 推荐码引入外部链接（仅在触屏上有用）
 */
export function codeExtLink() {
  if (webEntry() === 1) {
    var oscript = document.createElement('script');
    oscript.src =
      process.env.REACT_APP_PKG === 'dev'
        ? url.app_url + 'public/csmbpRecommendUtil.js'
        : url.login_url + 'static/public/csmbpRecommendUtil.js';
    document.body.appendChild(oscript);
  }
}



// WEBPACK FOOTER //
// ./src/utils/util_recommendCode.js